import { gql } from '@apollo/client';

export const GET_LIST_CONTACT_NOTE = gql`
  query GetList($where: Map, $sort: Map) {
    GetContactNoteList(
      pagination: { offset: 0, limit: 10, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on ContactNotes {
        data {
          id
          user_id
          user {
            ... on User {
              id
              email
              active_status
              created_at
              updated_at
              deleted_at
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                  name
                  file_size
                  file_type
                  object_name
                  bucket_name
                  url_link
                  created_at
                  deleted_at
                  updated_at
                }
              }
            }
          }
          contact_id
          contact {
            ... on Contact {
              id
              name
              team_id
              team {
                ... on Team {
                  name
                }
              }
              mobile_number
              whatsapp_number
              home_number
              line_id
              funnel_status
              email_address_1
              email_address_2
              email_address_1
              province_code
              country
              postal_code
              gender
              age
              birth_date
              nationality
              income_per_month
              parental_status
              married_status
              education_type
              ig_username
              fb_username
              linkedin_username
              twt_username
              ytb_username
              education_institutions
              expertises
              past_job_titles
              hobbies
              favorites
              #bio_detail
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                }
              }
              job
              organization_name
              related_organization
              created_by
              created_at
              updated_at
              deleted_at
            }
          }
          content
          created_at
        }
      }
    }
  }
`;

export const GET_CONTACTS_NOTE_BY_ID = gql`
  query GetByID($id: String!) {
    list: GetContactNoteByID(id: $id) {
      id
      user_id
      user {
        ... on User {
          id
          email
          active_status
          created_at
          updated_at
          deleted_at
          profile_pic_document_id
          profile_pic_document {
            ... on Document {
              id
              name
              file_size
              file_type
              object_name
              bucket_name
              url_link
              created_at
              deleted_at
              updated_at
            }
          }
        }
      }
      contact_id
      contact {
        ... on Contact {
          id
          name
          team_id
          team {
            ... on Team {
              name
            }
          }
          mobile_number
          whatsapp_number
          home_number
          line_id
          funnel_status
          email_address_1
          email_address_2
          email_address_1
          province_code
          country
          postal_code
          gender
          age
          birth_date
          nationality
          income_per_month
          parental_status
          married_status
          education_type
          ig_username
          fb_username
          linkedin_username
          twt_username
          ytb_username
          education_institutions
          expertises
          past_job_titles
          hobbies
          favorites
          #bio_detail
          profile_pic_document_id
          profile_pic_document {
            ... on Document {
              id
            }
          }
          job
          organization_name
          related_organization
          created_by
          created_at
          updated_at
          deleted_at
        }
      }
      content
    }
  }
`;
